import { Controller } from "@hotwired/stimulus"

// Drives the on/off switch UI (app/views/shared/_toggle.html.erb).
// Deliberately not built on tailwindcss-stimulus-components' Toggle: its API
// changed across major versions (v6 show/hides targets with `hidden` instead
// of toggling a configurable class), which is what broke this switch.
export default class extends Controller {
  static targets = ["toggleable"]
  static values = { open: { type: Boolean, default: false } }

  toggle(event) {
    if (event.target === this.checkbox) {
      // Native activation (label click / keyboard) already flipped the
      // checkbox before this handler ran — sync from it.
      this.openValue = this.checkbox.checked
    } else {
      // Stop the label's native activation from also toggling the checkbox,
      // which would bubble a second click back here and cancel this one out.
      event.preventDefault()
      this.openValue = !this.openValue
      this.checkbox.checked = this.openValue
    }

    this.toggleableTarget.classList.toggle("enabled", this.openValue)
  }

  get checkbox() {
    return this.element.querySelector("input[type=checkbox]")
  }
}
